export function email(value) {
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(value);
}

export function pincode(value) {
  const regex = /^[1-9][0-9]{4,6}$/;
  return regex.test(value);
}

export function mobile(value) {
  const regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  return regex.test(value);
}

export function otp(value) {
  const regex = /^\d{4}$/;
  return regex.test(value);
}

export function age(value) {
  if (!value) return true; // age is optional
  return /^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 99;
}

export function name(value) {
  if (!value) return true; // name is optional
  return /^[a-zA-Z\s'-]+$/.test(value.trim());
}

export function contact(value) {
  if (!value) return true; // contact is optional
  return /^[0-9]{10}$/.test(value);
}
